import { HowItWorksSection } from 'pages/Main/shared/components';
import { TrackNumberSection } from './components';

export const Home = () => {
    return (
        <>
            <TrackNumberSection />
            <HowItWorksSection />
        </>
    );
};
